var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3687",
    "data-name": "Group 3687",
    transform: "translate(-371 -214)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5128",
    "data-name": "Rectangle 5128",
    width: 24,
    height: 24,
    rx: 3,
    transform: "translate(371 214)",
    fill: "#c2fae5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-3556018",
    transform: "translate(375.168 218.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12441",
    "data-name": "Path 12441",
    d: "M265.769,100.8a1.873,1.873,0,0,0-1.334.553L261.29,104.5a3,3,0,0,0-.885,2.138v1.415h1.415a3,3,0,0,0,2.136-.885l3.147-3.147a1.887,1.887,0,0,0-1.334-3.219Zm.479,2.366L263.1,106.31a1.8,1.8,0,0,1-1.282.532h-.207v-.207a1.8,1.8,0,0,1,.53-1.282l3.147-3.147a.678.678,0,1,1,.958.958Z",
    transform: "translate(-257.987 -100.799)",
    stroke: "#c2fae5",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12442",
    "data-name": "Path 12442",
    d: "M172.613,132.264h5.438a1.813,1.813,0,0,0,1.813-1.813v-2.417h-1.208v2.417a.6.6,0,0,1-.6.6h-5.438a.6.6,0,0,1-.6-.6v-5.438a.6.6,0,0,1,.6-.6h2.417V123.2h-2.417a1.813,1.813,0,0,0-1.813,1.813v5.438a1.813,1.813,0,0,0,1.813,1.813Z",
    transform: "translate(-170.8 -122.596)",
    stroke: "#c2fae5",
    strokeWidth: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSmall);
export default __webpack_public_path__ + "static/media/edit_small.7c984ecf432b332a32a133cd8317141c.svg";
export { ForwardRef as ReactComponent };